// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_paragon_ui_styles" + "." + "372b346b" + ".chunk.css";
};